import React from "react";
import {FaAngleLeft, FaAngleRight} from "react-icons/fa";
import { Table } from 'semantic-ui-react';

const DOTS = '...';

const range = (start, end) => {
    const length = end - start + 1;
    return Array.from({ length }, (_, index) => index + start);
};

const getPaginationRange = (current, total, siblingCount = 1) => {
    const totalPageNumbers = siblingCount * 2 + 5;

    if (totalPageNumbers >= total) {
        return range(1, total);
    }

    const leftSiblingIndex = Math.max(current - siblingCount, 1);
    const rightSiblingIndex = Math.min(current + siblingCount, total);

    const shouldShowLeftDots = leftSiblingIndex > 2;
    const shouldShowRightDots = rightSiblingIndex < total - 2;

    if (!shouldShowLeftDots && shouldShowRightDots) {
        const leftItemCount = 3 + 2 * siblingCount;
        return [...range(1, leftItemCount), DOTS, total];
    }

    if (shouldShowLeftDots && !shouldShowRightDots) {
        const rightItemCount = 3 + 2 * siblingCount;
        return [1, DOTS, ...range(total - rightItemCount + 1, total)];
    }

    return [1, DOTS, ...range(leftSiblingIndex, rightSiblingIndex), DOTS, total];
};

const Pagination = (props) => {

    const numberOfPagesCounter = props.numberOfPages
    const actualPage = props.actualPage
    const pages = getPaginationRange(actualPage, numberOfPagesCounter)

    return (
        <Table.Row>
                <Table.HeaderCell colSpan='6'>
                    <div className="pagination">
                        <FaAngleLeft onClick={() => props.changePage(Math.max(actualPage - 1, 1))}/>
                            {pages.map((page, index) => (
                                page === DOTS
                                    ? <div key={`dots-${index}`} className="pagination-dots">{DOTS}</div>
                                    : <div key={page} onClick={() => props.changePage(page)} className={`${actualPage === page ? 'selected' : ''}`}> {page} </div>
                            ))}
                        <FaAngleRight onClick={() => props.changePage(Math.min(actualPage + 1, numberOfPagesCounter))} />
                    </div>
                </Table.HeaderCell>
            </Table.Row>
    )
}

export default Pagination
